import { extendTheme } from "@chakra-ui/react";
import { formatDate } from "./dateUtils";
import { learningModes } from "./LearningPathUtils";
import { StorageService } from "./StorageUtils";
import { answerEncryptText } from "./crypto";
import { getRandomVinMessage } from "../network/LearnApiService";
import emotionalMessages from "./emotionalScriptConstants";
export const isEmptyOrNull = (value) =>
  value === undefined ||
  value === "" ||
  value === null ||
  isEmptyArray(value) ||
  isEmptyObject(value);

const ZERO = 0;

function isObject(arg) {
  return typeof arg === "object" && !isNull(arg) && !isArray(arg);
}

function checkTommorow(dueDate, displayFullMonth = false, isTaskCard = false) {
  const dueDateString = dueDate?.split("T")[0];
  const formattedDueDate = new Date(dueDateString);
  const currentDate = new Date();
  const tomorrowDate = new Date();
  tomorrowDate.setDate(currentDate?.getDate() + 1);
  if (isTaskCard) {
    if (
      formattedDueDate.getFullYear() === tomorrowDate.getFullYear() &&
      formattedDueDate.getMonth() === tomorrowDate.getMonth() &&
      formattedDueDate.getDate() === tomorrowDate.getDate()
    ) {
      return "Tomorrow";
    } else if (
      formattedDueDate.getFullYear() === currentDate.getFullYear() &&
      formattedDueDate.getMonth() === currentDate.getMonth() &&
      formattedDueDate.getDate() === currentDate.getDate()
    ) {
      return "Today";
    } else if (formattedDueDate < currentDate) {
      return formatDate(dueDateString, displayFullMonth);
    } else {
      return formatDate(dueDateString, displayFullMonth);
    }
  } else {
    return formatDate(dueDateString, displayFullMonth);
  }
}

const checkRules = async (question, resultValue) => {
  let existScript = "";
  question?.rules?.forEach((result) => {
    if (
      result?.condition?.toLowerCase() === "greaterthanequal" &&
      resultValue >= Number(result?.value)
    ) {
      existScript = result?.dialog_exit_script?.content?.[0]?.text_layout;
    } else if (
      result?.condition?.toLowerCase() === "lessthanequal" &&
      resultValue <= Number(result?.value)
    ) {
      existScript = result?.dialog_exit_script?.content?.[0]?.text_layout;
    } else if (
      result?.condition?.toLowerCase() === "equal" &&
      resultValue === Number(result?.value)
    ) {
      existScript = result?.dialog_exit_script?.content?.[0]?.text_layout;
    }
  });
  return existScript;
};

const extractChatId = (userAnswer) => {
  try {
    return userAnswer?.chatId || "";
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return "";
  }
};

const getUserSelectedAnswer = (userAnswer, optionsArray) => {
  const selectedOption = optionsArray?.find((option) => {
    // Hash each option and compare with userAnswer
    const hashedOption = answerEncryptText(option);
    return hashedOption === userAnswer;
  });

  return selectedOption;
};

const taskTourData = [
  {
    element: "#cardsData",
    header: "Welcome @name! I'm Vin.",
    intro: `
    <h1 style="display: flex; align-items: center; gap: 8px; font-family: Poppins; margin-top: -15px; font-size: 16px; font-weight: 600; line-height: 24px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;"><span class="sparkle-icon"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M8.8132 14.9038L8 17.75L7.1868 14.9038C6.75968 13.4089 5.59112 12.2403 4.09619 11.8132L1.25 11L4.09619 10.1868C5.59113 9.75968 6.75968 8.59112 7.1868 7.09619L8 4.25L8.8132 7.09619C9.24032 8.59113 10.4089 9.75968 11.9038 10.1868L14.75 11L11.9038 11.8132C10.4089 12.2403 9.24032 13.4089 8.8132 14.9038Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
     <path d="M17.2589 7.71454L17 8.75L16.7411 7.71454C16.4388 6.50533 15.4947 5.56117 14.2855 5.25887L13.25 5L14.2855 4.74113C15.4947 4.43883 16.4388 3.49467 16.7411 2.28546L17 1.25L17.2589 2.28546C17.5612 3.49467 18.5053 4.43883 19.7145 4.74113L20.75 5L19.7145 5.25887C18.5053 5.56117 17.5612 6.50533 17.2589 7.71454Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
     <path d="M15.8942 19.5673L15.5 20.75L15.1058 19.5673C14.8818 18.8954 14.3546 18.3682 13.6827 18.1442L12.5 17.75L13.6827 17.3558C14.3546 17.1318 14.8818 16.6046 15.1058 15.9327L15.5 14.75L15.8942 15.9327C16.1182 16.6046 16.6454 17.1318 17.3173 17.3558L18.5 17.75L17.3173 18.1442C16.6454 18.3682 16.1182 18.8954 15.8942 19.5673Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
     </svg>
     </span> Homework list</h1>
    <p style="font-family: Poppins; font-size: 14px; font-weight: 400; line-height: 22px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">Find the list of homework your teacher has assigned. Quickly get to see the latest feedback from the teacher as well</p>`,
    position: "top",
    tooltipClass: "custom-tooltip",
  },
  {
    element: "#menuIcon1",
    header: "Welcome @name! I'm Vin.",
    intro: `<h1 style="display: flex; align-items: center; gap: 8px; font-family: Poppins; margin-top: -15px; font-size: 16px; font-weight: 600; line-height: 24px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;"><span class="sparkle-icon"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.8132 14.9038L8 17.75L7.1868 14.9038C6.75968 13.4089 5.59112 12.2403 4.09619 11.8132L1.25 11L4.09619 10.1868C5.59113 9.75968 6.75968 8.59112 7.1868 7.09619L8 4.25L8.8132 7.09619C9.24032 8.59113 10.4089 9.75968 11.9038 10.1868L14.75 11L11.9038 11.8132C10.4089 12.2403 9.24032 13.4089 8.8132 14.9038Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.2589 7.71454L17 8.75L16.7411 7.71454C16.4388 6.50533 15.4947 5.56117 14.2855 5.25887L13.25 5L14.2855 4.74113C15.4947 4.43883 16.4388 3.49467 16.7411 2.28546L17 1.25L17.2589 2.28546C17.5612 3.49467 18.5053 4.43883 19.7145 4.74113L20.75 5L19.7145 5.25887C18.5053 5.56117 17.5612 6.50533 17.2589 7.71454Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.8942 19.5673L15.5 20.75L15.1058 19.5673C14.8818 18.8954 14.3546 18.3682 13.6827 18.1442L12.5 17.75L13.6827 17.3558C14.3546 17.1318 14.8818 16.6046 15.1058 15.9327L15.5 14.75L15.8942 15.9327C16.1182 16.6046 16.6454 17.1318 17.3173 17.3558L18.5 17.75L17.3173 18.1442C16.6454 18.3682 16.1182 18.8954 15.8942 19.5673Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg></span> Homework</h1>
    <p style="font-family: Poppins; font-size: 14px; font-weight: 400; line-height: 22px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">Quick link to the homework page. Access the link from the menu, to check the list and stay up-to-date</p>`,
    position: "top",
    tooltipClass: "custom-tooltip",
  },
  {
    element: "#menuIcon2",
    intro: `<h1 style="display: flex; align-items: center; gap: 8px; font-family: Poppins; margin-top: -15px; font-size: 16px; font-weight: 600; line-height: 24px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;"><span class="sparkle-icon"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.8132 14.9038L8 17.75L7.1868 14.9038C6.75968 13.4089 5.59112 12.2403 4.09619 11.8132L1.25 11L4.09619 10.1868C5.59113 9.75968 6.75968 8.59112 7.1868 7.09619L8 4.25L8.8132 7.09619C9.24032 8.59113 10.4089 9.75968 11.9038 10.1868L14.75 11L11.9038 11.8132C10.4089 12.2403 9.24032 13.4089 8.8132 14.9038Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.2589 7.71454L17 8.75L16.7411 7.71454C16.4388 6.50533 15.4947 5.56117 14.2855 5.25887L13.25 5L14.2855 4.74113C15.4947 4.43883 16.4388 3.49467 16.7411 2.28546L17 1.25L17.2589 2.28546C17.5612 3.49467 18.5053 4.43883 19.7145 4.74113L20.75 5L19.7145 5.25887C18.5053 5.56117 17.5612 6.50533 17.2589 7.71454Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.8942 19.5673L15.5 20.75L15.1058 19.5673C14.8818 18.8954 14.3546 18.3682 13.6827 18.1442L12.5 17.75L13.6827 17.3558C14.3546 17.1318 14.8818 16.6046 15.1058 15.9327L15.5 14.75L15.8942 15.9327C16.1182 16.6046 16.6454 17.1318 17.3173 17.3558L18.5 17.75L17.3173 18.1442C16.6454 18.3682 16.1182 18.8954 15.8942 19.5673Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg></span> Class updates</h1>
    <p style="font-family: Poppins; font-size: 14px; font-weight: 400; line-height: 22px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">Missed a day at school? No problem! Catch up with the summary of all updates on your class</p>`,
    position: "top",
    tooltipClass: "custom-tooltip",
  },
  {
    element: "#menuIcon3",
    intro: `<h1 style="display: flex; align-items: center; gap: 8px; font-family: Poppins; margin-top: -15px; font-size: 16px; font-weight: 600; line-height: 24px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;"><span class="sparkle-icon"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.8132 14.9038L8 17.75L7.1868 14.9038C6.75968 13.4089 5.59112 12.2403 4.09619 11.8132L1.25 11L4.09619 10.1868C5.59113 9.75968 6.75968 8.59112 7.1868 7.09619L8 4.25L8.8132 7.09619C9.24032 8.59113 10.4089 9.75968 11.9038 10.1868L14.75 11L11.9038 11.8132C10.4089 12.2403 9.24032 13.4089 8.8132 14.9038Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.2589 7.71454L17 8.75L16.7411 7.71454C16.4388 6.50533 15.4947 5.56117 14.2855 5.25887L13.25 5L14.2855 4.74113C15.4947 4.43883 16.4388 3.49467 16.7411 2.28546L17 1.25L17.2589 2.28546C17.5612 3.49467 18.5053 4.43883 19.7145 4.74113L20.75 5L19.7145 5.25887C18.5053 5.56117 17.5612 6.50533 17.2589 7.71454Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.8942 19.5673L15.5 20.75L15.1058 19.5673C14.8818 18.8954 14.3546 18.3682 13.6827 18.1442L12.5 17.75L13.6827 17.3558C14.3546 17.1318 14.8818 16.6046 15.1058 15.9327L15.5 14.75L15.8942 15.9327C16.1182 16.6046 16.6454 17.1318 17.3173 17.3558L18.5 17.75L17.3173 18.1442C16.6454 18.3682 16.1182 18.8954 15.8942 19.5673Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg></span> Self study</h1>
    <p style="font-family: Poppins; font-size: 14px; font-weight: 400; line-height: 22px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">This gives you the list of subtopics unlocked by your teacher. You may select one to explore and learn. It also indicates your progress</p>`,
    position: "top",
    tooltipClass: "custom-tooltip",
  },
];

const taskTourDataWithoutTasks = [
  {
    element: "#noTasks",

    intro: `
    <h1 style="display: flex; align-items: center; gap: 8px; font-family: Poppins; margin-top: -15px; font-size: 16px; font-weight: 600; line-height: 24px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;"><span class="sparkle-icon"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M8.8132 14.9038L8 17.75L7.1868 14.9038C6.75968 13.4089 5.59112 12.2403 4.09619 11.8132L1.25 11L4.09619 10.1868C5.59113 9.75968 6.75968 8.59112 7.1868 7.09619L8 4.25L8.8132 7.09619C9.24032 8.59113 10.4089 9.75968 11.9038 10.1868L14.75 11L11.9038 11.8132C10.4089 12.2403 9.24032 13.4089 8.8132 14.9038Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
     <path d="M17.2589 7.71454L17 8.75L16.7411 7.71454C16.4388 6.50533 15.4947 5.56117 14.2855 5.25887L13.25 5L14.2855 4.74113C15.4947 4.43883 16.4388 3.49467 16.7411 2.28546L17 1.25L17.2589 2.28546C17.5612 3.49467 18.5053 4.43883 19.7145 4.74113L20.75 5L19.7145 5.25887C18.5053 5.56117 17.5612 6.50533 17.2589 7.71454Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
     <path d="M15.8942 19.5673L15.5 20.75L15.1058 19.5673C14.8818 18.8954 14.3546 18.3682 13.6827 18.1442L12.5 17.75L13.6827 17.3558C14.3546 17.1318 14.8818 16.6046 15.1058 15.9327L15.5 14.75L15.8942 15.9327C16.1182 16.6046 16.6454 17.1318 17.3173 17.3558L18.5 17.75L17.3173 18.1442C16.6454 18.3682 16.1182 18.8954 15.8942 19.5673Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
     </svg>
     </span> Homework list</h1>
    <p style="font-family: Poppins; font-size: 14px; font-weight: 400; line-height: 22px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">When your teacher assigns homework, you'll see them here</p>`,
    position: "top",
    tooltipClass: "custom-tooltip",
  },
  {
    element: "#menuIcon1",
    header: "Welcome @name! I'm Vin.",
    intro: `<h1 style="display: flex; align-items: center; gap: 8px; font-family: Poppins; margin-top: -15px; font-size: 16px; font-weight: 600; line-height: 24px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;"><span class="sparkle-icon"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.8132 14.9038L8 17.75L7.1868 14.9038C6.75968 13.4089 5.59112 12.2403 4.09619 11.8132L1.25 11L4.09619 10.1868C5.59113 9.75968 6.75968 8.59112 7.1868 7.09619L8 4.25L8.8132 7.09619C9.24032 8.59113 10.4089 9.75968 11.9038 10.1868L14.75 11L11.9038 11.8132C10.4089 12.2403 9.24032 13.4089 8.8132 14.9038Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.2589 7.71454L17 8.75L16.7411 7.71454C16.4388 6.50533 15.4947 5.56117 14.2855 5.25887L13.25 5L14.2855 4.74113C15.4947 4.43883 16.4388 3.49467 16.7411 2.28546L17 1.25L17.2589 2.28546C17.5612 3.49467 18.5053 4.43883 19.7145 4.74113L20.75 5L19.7145 5.25887C18.5053 5.56117 17.5612 6.50533 17.2589 7.71454Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.8942 19.5673L15.5 20.75L15.1058 19.5673C14.8818 18.8954 14.3546 18.3682 13.6827 18.1442L12.5 17.75L13.6827 17.3558C14.3546 17.1318 14.8818 16.6046 15.1058 15.9327L15.5 14.75L15.8942 15.9327C16.1182 16.6046 16.6454 17.1318 17.3173 17.3558L18.5 17.75L17.3173 18.1442C16.6454 18.3682 16.1182 18.8954 15.8942 19.5673Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg></span> Homework</h1>
    <p style="font-family: Poppins; font-size: 14px; font-weight: 400; line-height: 22px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">Quick link to the homework page. Access the link from the menu, to check the list and stay up-to-date</p>`,
    position: "top",
    tooltipClass: "custom-tooltip",
  },
  {
    element: "#menuIcon2",
    intro: `<h1 style="display: flex; align-items: center; gap: 8px; font-family: Poppins; margin-top: -15px; font-size: 16px; font-weight: 600; line-height: 24px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;"><span class="sparkle-icon"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.8132 14.9038L8 17.75L7.1868 14.9038C6.75968 13.4089 5.59112 12.2403 4.09619 11.8132L1.25 11L4.09619 10.1868C5.59113 9.75968 6.75968 8.59112 7.1868 7.09619L8 4.25L8.8132 7.09619C9.24032 8.59113 10.4089 9.75968 11.9038 10.1868L14.75 11L11.9038 11.8132C10.4089 12.2403 9.24032 13.4089 8.8132 14.9038Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.2589 7.71454L17 8.75L16.7411 7.71454C16.4388 6.50533 15.4947 5.56117 14.2855 5.25887L13.25 5L14.2855 4.74113C15.4947 4.43883 16.4388 3.49467 16.7411 2.28546L17 1.25L17.2589 2.28546C17.5612 3.49467 18.5053 4.43883 19.7145 4.74113L20.75 5L19.7145 5.25887C18.5053 5.56117 17.5612 6.50533 17.2589 7.71454Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.8942 19.5673L15.5 20.75L15.1058 19.5673C14.8818 18.8954 14.3546 18.3682 13.6827 18.1442L12.5 17.75L13.6827 17.3558C14.3546 17.1318 14.8818 16.6046 15.1058 15.9327L15.5 14.75L15.8942 15.9327C16.1182 16.6046 16.6454 17.1318 17.3173 17.3558L18.5 17.75L17.3173 18.1442C16.6454 18.3682 16.1182 18.8954 15.8942 19.5673Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg></span> Class updates</h1>
    <p style="font-family: Poppins; font-size: 14px; font-weight: 400; line-height: 22px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">Missed a day at school? No problem! Catch up with the summary of all updates on your class</p>`,
    position: "top",
    tooltipClass: "custom-tooltip",
  },
  {
    element: "#menuIcon3",
    intro: `<h1 style="display: flex; align-items: center; gap: 8px; font-family: Poppins; margin-top: -15px; font-size: 16px; font-weight: 600; line-height: 24px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;"><span class="sparkle-icon"><svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.8132 14.9038L8 17.75L7.1868 14.9038C6.75968 13.4089 5.59112 12.2403 4.09619 11.8132L1.25 11L4.09619 10.1868C5.59113 9.75968 6.75968 8.59112 7.1868 7.09619L8 4.25L8.8132 7.09619C9.24032 8.59113 10.4089 9.75968 11.9038 10.1868L14.75 11L11.9038 11.8132C10.4089 12.2403 9.24032 13.4089 8.8132 14.9038Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M17.2589 7.71454L17 8.75L16.7411 7.71454C16.4388 6.50533 15.4947 5.56117 14.2855 5.25887L13.25 5L14.2855 4.74113C15.4947 4.43883 16.4388 3.49467 16.7411 2.28546L17 1.25L17.2589 2.28546C17.5612 3.49467 18.5053 4.43883 19.7145 4.74113L20.75 5L19.7145 5.25887C18.5053 5.56117 17.5612 6.50533 17.2589 7.71454Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.8942 19.5673L15.5 20.75L15.1058 19.5673C14.8818 18.8954 14.3546 18.3682 13.6827 18.1442L12.5 17.75L13.6827 17.3558C14.3546 17.1318 14.8818 16.6046 15.1058 15.9327L15.5 14.75L15.8942 15.9327C16.1182 16.6046 16.6454 17.1318 17.3173 17.3558L18.5 17.75L17.3173 18.1442C16.6454 18.3682 16.1182 18.8954 15.8942 19.5673Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg></span> Self study</h1>
    <p style="font-family: Poppins; font-size: 14px; font-weight: 400; line-height: 22px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">This gives you the list of subtopics unlocked by your teacher. You may select one to explore and learn. It also indicates your progress</p>`,
    position: "top",
    tooltipClass: "custom-tooltip",
  },
];

function isEmptyObject(arg) {
  return isObject(arg) && Object.keys(arg).length === ZERO;
}

function isFunction(arg) {
  return typeof arg === "function";
}

function isNumber(arg) {
  return typeof arg === "number";
}

function isString(arg) {
  return typeof arg === "string";
}

function isArray(arg) {
  return Array.isArray(arg);
}

function isEmptyArray(arg) {
  return arg === undefined || (isArray(arg) && arg.length === ZERO);
}

function isNull(arg) {
  return arg === null;
}

function isUndefined(arg) {
  return arg === void ZERO || arg === undefined;
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
function shuffleArray(array) {
  return array.sort(() => Math.random() - 0.5);
}
export const isUserLogin = () => {
  const isLogin = StorageService.getItem("xUserId");
  const user_details = StorageService.getItem("user_details");
  if (isNotEmptyOrNull(user_details)) {
    try {
      // First check if user_details is already an object
      const userObj =
        typeof user_details === "object"
          ? user_details
          : JSON.parse(user_details);

      const status =
        isLogin != null &&
        isLogin != "undefined" &&
        isLogin != "" &&
        userObj?.registrationStatus.toString() === "4";

      return !!status;
    } catch (error) {
      return false;
    }
  } else {
    return false;
  }
};

const shuffleArrayData = (array) => {
  var arrayObj = [];
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.rndom() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  arrayObj = array;
  return arrayObj;
};
function isNotEmptyOrNull(data) {
  return (
    data !== undefined &&
    data !== "undefined" &&
    data !== null &&
    !isEmptyArray(data) &&
    data !== "" &&
    !isEmptyObject(data)
  );
}

function isNotUndefinedOrNull(data) {
  return data !== undefined && data !== null;
}

function extractGivenAnswers(inputData) {
  let answerResult = inputData.answerResult;
  const givenAnswers = Array.isArray(answerResult)
    ? answerResult.map((item) => item?.givenAnswer)
    : [];
  return givenAnswers;
}

function convertArrayWithSeperator(text) {
  if (Array.isArray(text)) {
    return text.join(", ");
  }
  return text;
}
const getUserInfo = async () => {
  let userDetails = StorageService.getItem("user_details");
  userDetails =
    typeof userDetails === "object" ? userDetails : JSON.parse(userDetails);
  try {
    return userDetails;
  } catch (e) {
    return {};
  }
};

const getUseradditionaldetails = async () => {
  let user_additionaldetails = StorageService.getItem(
    "user_additional_details"
  );

  try {
    user_additionaldetails =
      typeof user_additionaldetails === "object"
        ? user_additionaldetails
        : JSON.parse(user_additionaldetails);
    return user_additionaldetails;
  } catch (e) {
    return {};
  }
};

const getTimeDifference = async (startTime, endTime) => {
  let diffMs = endTime - startTime;
  let seconds = Math.floor(diffMs / 1000);
  return seconds;
};

const urlString = "/school/aitutor";
const tutorString = "/aitutor";

const downloadUrl = (url, fileName) => {
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document?.createElement("a");
      link.href = url;
      link.download = fileName || "downloaded-file";
      document?.body.appendChild(link);

      link.click();

      document?.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error("Error fetching the file:", error);
    });
};

const PATTERN1 = /<p>&nbsp;<\/p>/g;
const PATTERN2 = /<p><br>&nbsp;<\/p>/g;
const PATTERN3 = /&nbsp;<br>&nbsp;<\/p>/g;
const PATTERN4 = /<br><br>&nbsp;<\/p>/g;
const PATTERN5 = /<br>&nbsp;/g;
const PATTERN6 = /<\/p><p>&nbsp;/g;
const PATTERN7 = /<br>&nbsp;/g;

const handleRemoveExtraSpaceInBubbles = (html = "") => {
  const cleanPatterns = [
    /<p>&nbsp;<\/p>/g,
    /<p><br>&nbsp;<\/p>/g,
    /&nbsp;<br>&nbsp;<\/p>/g,
    /<br><br>&nbsp;<\/p>/g,
    /<br>&nbsp;/g,
    /<\/p><p>&nbsp;/g,
    /<br>/g,
  ];

  return cleanPatterns.reduce((cleanedHtml, pattern) => {
    return cleanedHtml.replace(pattern, "");
  }, String(html));
};

export const onlyTagsExist = (content) => {
  return /^(\s*<[^>]+>\s*)+$/i.test(content);
};

const hasLongString = (array) => {
  return array.some((item) => item.length > 30);
};

const customTheme = extendTheme({
  fontStyle: {
    heading: `'Poppins', sans-serif`,
    body: `'Poppins', sans-serif`,
    mono: `'Poppins', sans-serif`,
  },
});
const excludeSubjects = ["english", "mathematics"];

const mergeSchoolUpdatesArray = (arr1, arr2) => {
  let mergedArray = [];
  let i = 0;
  let j = 0;

  while (i < arr1.length && j < arr2.length) {
    if (arr1[i]?.timestamp > arr2[j]?.timestamp) {
      mergedArray.push(arr1[i]);
      i++;
    } else {
      mergedArray.push(arr2[j]);
      j++;
    }
  }
  while (i < arr1.length) {
    mergedArray.push(arr1[i]);
    i++;
  }

  while (j < arr2.length) {
    mergedArray.push(arr2[j]);
    j++;
  }

  return mergedArray;
};

export const thumnail_url =
  "https://s3.ap-south-1.amazonaws.com/dev-ui.innerscore.com/video-x-generic-icon-512x506-axcin1bz.png";

export const getEmotionalMessageText = async (index) => {
  const response = await getRandomVinMessage(index);
  if (response?.data?.message && response?.data?.status === true) {
    return response.data.message;
  } else {
    return getDefaultAssistantText(index);
  }
};

// Provide a default emotional message if API call fails
const getDefaultAssistantText = (index) => {
  const messages = emotionalMessages[0][index];
  const randomIndex = Math.floor(Math.random() * messages.length);
  return messages[randomIndex];
};

export const getUpdateJourneyDetails = (learningStepData, journeyId) => {
  let basketId = isNotEmptyOrNull(learningStepData?.basket)
    ? learningStepData?.basket
    : isNotEmptyOrNull(learningStepData?.prerequisite_id)
    ? learningStepData?.prerequisite_id
    : isNotEmptyOrNull(learningStepData?.gp_id)
    ? learningStepData?.gp_id
    : isNotEmptyOrNull(learningStepData?.assessment_id)
    ? learningStepData?.assessment_id
    : null;

  let journey = isNotEmptyOrNull(learningStepData?.journey_id)
    ? learningStepData?.journey_id
    : journeyId;

  return { basketId, journey };
};

export const storeImage = async (file) => {
  try {
    const response = await fetch(file);
    const blob = await response.blob();

    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => {
      StorageService.setItem("savedImage", reader.result);
    };
  } catch (error) {
    console.error("Error storing image:", error);
  }
};

export const formatAppBarTitle = (mainText, obj) => {
  return `${mainText} ${obj?.subjectName ? `| ${obj.subjectName}` : ""} ${
    obj?.topicName ? `| ${obj.topicName}` : ""
  } ${obj?.subtopicName ? `| ${obj.subtopicName}` : ""}`;
};

export const cleanTextContent = (text) => {
  if (!text) return text;

  // Patterns to match various combinations of empty content
  const patterns = [
    /^(\s*<br\s*\/?>\s*)+$/, // Only <br> tags
    /^(\s*&nbsp;\s*)+$/, // Only &nbsp;
    /^(\s*<div[^>]*>\s*<\/div>\s*)+$/, // Only empty div tags
    /^(\s*(<br\s*\/?>|&nbsp;)\s*)+$/, // Combination of <br> and &nbsp;
    /^(\s*(<div[^>]*>|&nbsp;)\s*<\/div>\s*)+$/, // Combination of <div> and &nbsp;
    /^(\s*(<div[^>]*>|<br\s*\/?>)\s*<\/div>\s*)+$/, // Combination of <div> and <br>
    /^(\s*(<div[^>]*>|<br\s*\/?>|&nbsp;)\s*<\/div>\s*)+$/, // Combination of all three
  ];

  // Check if the text matches any of the patterns
  const isOnlyEmptyContent = patterns.some((pattern) => pattern.test(text));

  // If it matches any pattern, return empty string
  if (isOnlyEmptyContent) {
    return "";
  }

  return text;
};

 export const handleVideoEvent = (eventObj,learningStepData,taskType,selectedTopic) => {
    // Get context data for video events
    let backUpObject = StorageService.getItem("backUpObject");
    let { basketId, journey } = getUpdateJourneyDetails(learningStepData, "");
  
    // Get stored video events or create new structure
    let storedData = StorageService.getItem("videoEvents");
    let inputObj = storedData ? JSON.parse(storedData) : null;

    if (inputObj) {
      inputObj.events.push(eventObj);
    } else {
      inputObj = {
        grade_id: StorageService.getItem("gradeId"),
        basket_id: basketId,
        journey_id: journey,
        journey_type: taskType || backUpObject?.taskType,
        step_id: learningStepData?.step_id,
        topic_id:
          selectedTopic?.topic?.topicMasterUuid ||
          backUpObject?.topicMasterUuid,
        question_id:
          learningStepData?.questions?.[0]?.version_uuid ||
          learningStepData?._id,
        events: [eventObj],
      };
    }

    StorageService.setItem("videoEvents", JSON.stringify(inputObj));
  };

export {
  isArray,
  isEmptyArray,
  isEmptyObject,
  isFunction,
  isNull,
  isNumber,
  isObject,
  isString,
  isUndefined,
  capitalize,
  isNotEmptyOrNull,
  isNotUndefinedOrNull,
  shuffleArray,
  shuffleArrayData,
  convertArrayWithSeperator,
  getUserInfo,
  getUseradditionaldetails,
  extractGivenAnswers,
  handleRemoveExtraSpaceInBubbles,
  downloadUrl,
  checkTommorow,
  customTheme,
  excludeSubjects,
  hasLongString,
  urlString,
  tutorString,
  mergeSchoolUpdatesArray,
  checkRules,
  getTimeDifference,
  getUserSelectedAnswer,
  taskTourData,
  taskTourDataWithoutTasks,
  extractChatId,
  
};
